export const iconFontAwesomeMovingTape = (
	<i className="fa-solid fa-tape"></i>
);
